/**
 * Resolves the map result that corresponds to a focused listing.
 *
 * Resolution order:
 * 1. communityId match restricted to HousingDevelopment / BuildablePlan types.
 * 2. Falls back to an exact id match across all types.
 *
 * Pure function — no side effects.
 *
 * @param {{ id: string, communityId: string }} focusedListing
 * @param {Object} state - Redux state snapshot.
 * @returns {Object|null} The matching map result, or null if not found.
 */

import { selectMapResults } from '../redux/selectors';
import MarkerType from '../enums/markerType';

const COMMUNITY_MARKER_TYPES = [
  MarkerType.HousingDevelopment.toString(),
  MarkerType.BuildablePlan.toString(),
];

export default function resolveFocusedMapResult(focusedListing, state) {
  const results = selectMapResults(state);
  if (!results?.length || !focusedListing) {
    return null;
  }

  if (focusedListing.communityId) {
    const byCommunityId = results.find(({ communityId: resultCommunityId, type }) =>
      String(resultCommunityId) === String(focusedListing.communityId) &&
      COMMUNITY_MARKER_TYPES.includes(type)
    );

    if (byCommunityId) {
      return byCommunityId;
    }
  }

  if (focusedListing.id) {
    return results.find((result) => String(result.id) === String(focusedListing.id));
  }

  return null;
}
